/**
 * Set the consent parameter in the window.dataLayer array
 * @param {String} pref - should be 'allowed' or 'denied'
 * @param {String} action - should be 'default' or 'update'
 */
function setConsent(pref, action = 'update', region = false) {
	window.dataLayer = window.dataLayer || [];
	pref = pref ? pref : localStorage.getItem('cookiePref');
	if (!pref || !['allowed', 'denied'].includes(pref)) return;
	action = ['allowed', 'denied'].includes(action) ? action : 'update';
	let prefs = {
		'ad_storage': pref,
		'analytics_storage': pref,
		'ad_user_data': pref,
		'ad_personalization': pref
	};
	if (Array.isArray(region)) prefs.region = region;
	window.dataLayer.push('consent', action, prefs);
}

function setPrefsOnClick(event) {
	let button = event.target.closest('[data-cookie-pref]');
	if (!button) return;
	let pref = button.getAttribute('data-cookie-pref');
	console.log('cookiePref set to ' + pref + ' on click.');
	localStorage.setItem('cookiePref', pref);
	setConsent(pref, 'update');
}

// let EU =  ['AL','AD','AM','AT','BY','BE','BA','BG','CH','CY','CZ','DE','DK','EE','ES','FO','FI','FR','GB','GE','GI','GR','HU','HR','IE','IS','IT','LT','LU','LV','MC','MK','MT','NO','NL','PO','PT','RO','RU','SE','SI','SK','SM','TR','UA','VA'];

// set 'default' to 'allow' for all countries
// setConsent('allowed', 'default');

// set 'default' to 'denied' for EU countries
// setConsent('denied', 'default', EU);

document.addEventListener('click', setPrefsOnClick, false);
